import Vue from 'vue'
import VueRouter from 'vue-router'
import MainComponentVue from '@/components/MainComponent.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: MainComponentVue
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
